import React from 'react'
import ResetPasswordComplete from 'src/containers/ResetPasswordComplete'

const ResetPasswordCompletePage: React.FC = () => {
  return <ResetPasswordComplete />
}

export const PATH = '/pwd/complete' as const
export default ResetPasswordCompletePage
